import { ActionWidget, CustomIcon, Header } from 'datastake-daf/dist/components';
import Style from '../../../../Analysis/style';
import LayoutStyle from '../../../../Analysis/layouts/style';
import { useTranslation } from 'react-i18next';
import KeyIndicators from './components/key-indicators';
import MapWidget from './components/map';
import RisksWidget from './components/risks-widget';
import { useState } from 'react';
import Settings from './components/settings';
import { useEffect } from 'react';
import PartnerService from '../../../../../services/PartnerService';
import Loading from '../../../../../components/Loading';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TerritorialDistribution from './components/risks-widget/components/territorial-distribution';
import FieldStories from './components/risks-widget/components/fieldStories';

export default function TazamaDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [partners, setPartners] = useState([]);
  const [selectedParters, setSelectedPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useSelector((state) => state.authentication);

  useEffect(() => {
    const _fetch = async () => {
      setLoading(true);

      try {
        const { data } = await PartnerService.get(null, { page: 1, pageSize: 100, type: 'partners' });
        const _partners = [
          { nickName: t('Own Data'), id: user?.company?.id },
          ...(data.data || [])
            .filter((v) => v.status === 'active' && ['source', 'exchange'].includes(v.partnershipType))
            .map((v) => ({ ...v, id: v?.company?.id })),
        ];
        setPartners(_partners);
        setSelectedPartners(_partners.map((s) => s.id));
      } catch (err) {
        console.log(err);
      }

      setLoading(false);
    };

    _fetch();
  }, []);

  return (
    <Style>
      <Header
        title={t('Conflict & GBV Monitoring')}
        supportText={(
          <>
            {t("Supported by")}
            {' '}
            <a href='https://unwomen.org/' target="_blank" rel="noreferrer">{t('UN Women')}</a>
            {' '}
            {t('and the ')}
            <a href='https://www.norway.no/fr/democratic-republic-of-congo/' target="_blank" rel="noreferrer">{t('Ambassade de Norvège')}</a>
          </>
        )}
        actionButtons={[
          {
            label: (
              <div className="flex flex-column justify-content-center h-100 settings-icon">
                <CustomIcon name="Settings" width={16} height={16} />
              </div>
            ),
            onClick: () => setSettingsVisible(true),
          },
        ]}
      />

      {loading && <Loading />}

      <div className="content">
        <div className="view-content">
          <LayoutStyle>
            <div className='sections-cont w-pt'>
              <section>
                <ActionWidget
                  icon="Annotation"
                  title={t('Compile Testimonial')}
                  onClick={() => navigate('/app/tazama/testimonials?create=true')}
                />
                <ActionWidget
                  icon="Alert"
                  title={t('Report Incident')}
                  onClick={() => navigate('/app/tazama/incidents?create=true')}
                />
                <ActionWidget
                  icon="ClipboardCheck"
                  title={t('Report Corrective Action')}
                  onClick={() => navigate('/app/tazama/corrective-actions?create=true')}
                />
                <ActionWidget
                  icon="Search"
                  title={t('Find Information')}
                  onClick={() => navigate('/app/tazama/find-information')}
                />
                <ActionWidget
                  icon="Share"
                  title={t('Share Information')}
                  onClick={() => navigate('/app/tazama/partners')}
                />
              </section>

              <section>
                <KeyIndicators
                  loading={loading}
                  selectedParters={selectedParters}
                />
              </section>

              <section>
                <MapWidget
                  loading={loading}
                  selectedParters={selectedParters}
                />
                
                <FieldStories
                  partnersLoading={loading}
                  partners={partners}
                  selectedParters={selectedParters}
                />
              </section>

              <section>
                <RisksWidget
                  loading={loading}
                  partners={partners}
                  selectedParters={selectedParters}
                />
              </section>
              <section>
                <RisksWidget
                  loading={loading}
                  partners={partners}
                  category='genderBasedViolence'
                  type="genderBasedViolence"
                  title='Gender-Based Violence Overview'
                  selectedParters={selectedParters}
                />
              </section>
            </div>
          </LayoutStyle>
        </div>
      </div>

      <Settings
        partners={partners}
        settingsVisible={settingsVisible}
        selectedParters={selectedParters}
        setSettingsVisible={setSettingsVisible}
        setSelectedPartners={setSelectedPartners}
      />
    </Style>
  )
}
